import { action, decorate, observable } from "mobx";

class ForgeSnackbarStore {
  isOpen = false;
  // One entry per Forge destination a clip was posted to: { destination, url }.
  forgeLinks = [];

  handleClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }

    this.isOpen = false;
    this.forgeLinks = [];
  }

  handleOpen(links) {
    this.forgeLinks = links;
    this.isOpen = true;
  }
}

decorate(ForgeSnackbarStore, {
  isOpen: observable,
  forgeLinks: observable,
  handleOpen: action
});

export default ForgeSnackbarStore;



// WEBPACK FOOTER //
// ./src/stores/ForgeSnackbarStore.js